import React from "react";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import useController from "./controller";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";

export default function ResetModal() {
  const { resetGameProgress, isGameReseting, closeModal } = useController();
  const { t } = useTranslation();
  return (
    <BaseModal
      eventTypeModal={MODAL_TYPES.RESET}
      title={t("modals.reset_game.title")}
      className="reset-modal"
      titleStyle="reset-modal__title"
      descriptionStyle="reset-modal__desc"
    >
      <BaseButton
        typeSpinner="light"
        onClick={resetGameProgress}
        loading={isGameReseting}
        negative={true}
      >
        {t("modals.reset_game.btn_reset")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        onClick={() => closeModal(MODAL_TYPES.RESET)}
        className="modal-button-cancel"
      >
        {t("modals.reset_game.btn_positive")}
      </BaseButton>
    </BaseModal>
  );
}
